import moment from 'moment';
import React, { Fragment, PureComponent, ReactNode } from 'react';
import { RouteComponentProps } from 'react-router';
import { AnimatePresence, motion } from 'framer-motion';

import { GO_TO_FEED, PostPageRouterProps } from '../routes';
import { PostsResponse } from '../../api/fetchPostByDocId';
import PullToRefreshWrapper from '../../components/PullToRefreshWrapper';
import fetchPostById from '../../api/fetchPostById';

type State = {
    fetchState: 'loading' | 'error' | 'success';
    postFetchState: 'loading' | 'error' | 'success';
    response?: PostsResponse;
    isCollapsed: boolean;
};

type Props = RouteComponentProps<PostPageRouterProps>;

const LIST = 'list';

class PostPage extends PureComponent<Props, State> {
    state: State = {
        fetchState: 'loading',
        postFetchState: 'loading',
        isCollapsed: false,
    };

    goBack = (): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.Eka?.closeActivity();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window?.webkit?.messageHandlers?.dismissHandler?.postMessage({});
    };

    componentDidMount = (): void => {
        this.fetchStuff();

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // window?.webkit?.messageHandlers?.logHandler?.postMessage(window);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window?.webkit?.messageHandlers?.navBarInfo?.postMessage({
            title: '',
            toolbar: false,
            pic: '',
            share: '',
            backAction: 'STACK-BACK',
        });
    };

    fetchStuff = (): void => {
        if (
            this.state.response?.profile?._id
            // && this.props.match.params.docId === this.state.response?.profile?._id
        ) {
            return;
        }

        this.setState({
            postFetchState: 'loading',
        });

        this.callApi();
    };

    callApi = async (): Promise<void> => {
        return fetchPostById(this.props.match.params.postId || '')
            .then((res) => {
                this.setState({
                    fetchState: 'success',
                    postFetchState: 'success',
                    response: res,
                });

                // if (!this.props.match.params.docId && res.profile?._id) {
                //     this.props.history.replace(GO_TO_FEED(res.profile._id, ''));
                // } else

                if (this.props.match.params.postId) {
                    setTimeout(() => {
                        if (this.props.match.params.postId) {
                            const postDiv = document.getElementById(this.props.match.params.postId);
                            if (postDiv) {
                                postDiv.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                    inline: 'nearest',
                                });
                            }
                        }
                    }, 500);
                }

                setTimeout(() => {
                    this.setScrollListner();
                }, 200);
            })
            .catch((e) => {
                this.setState({
                    fetchState: 'error',
                });
            });
    };

    onDocSelect = (docId: string): void => {
        this.props.history.replace(GO_TO_FEED(docId, ''));
    };

    setScrollListner = (): void => {
        const scrollList = document.getElementById(LIST) as HTMLDivElement;

        if (!scrollList) {
            console.error('not found');
            return;
        }
        scrollList.addEventListener('scroll', (e) => {
            const newLocal = scrollList.scrollTop > 172;
            // if (newLocal && !this.state.isCollapsed) {
            //     scrollList.scrollTop = 0;
            // }

            this.setState({
                isCollapsed: newLocal,
            });
        });
    };

    render(): ReactNode {
        const { fetchState, response, postFetchState, isCollapsed } = this.state;

        if (fetchState === 'loading') {
            return <FeedLoader />;
        }

        const currentDoc = response?.alldoctors && response?.alldoctors[0];

        return (
            <div className="flex flex-col w-full h-full overflow-hidden">
                <div
                    className={`flex items-center justify-between w-full ${
                        isCollapsed ? 'border-b border-seperator-dark' : ''
                    }`}
                >
                    <div className="flex items-center w-full">
                        {!isCollapsed || !currentDoc ? (
                            <p className="p-16 leading-6 text-text-primary text-20 font-700 z-10">
                                My Feed
                            </p>
                        ) : (
                            <div
                                style={{ margin: 16, height: 32, width: '100%' }}
                                className="relative w-full"
                            >
                                {currentDoc && (
                                    <motion.div
                                        initial={{
                                            position: 'absolute',
                                            bottom: -20,
                                            left: 0,
                                            right: 0,
                                            opacity: 0,
                                            width: '100%',
                                        }}
                                        animate={{
                                            top: 0,
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            opacity: 1,
                                        }}
                                        className="flex items-center space-x-12 font-700"
                                    >
                                        <img
                                            src={
                                                currentDoc?.profile.personal.pic_small ||
                                                currentDoc?.profile.personal.pic
                                            }
                                            className="h-32 w-32 rounded-8"
                                        />
                                        <span>
                                            Dr.{' '}
                                            {[
                                                currentDoc?.profile.personal.name.f,
                                                currentDoc?.profile.personal.name.l,
                                            ]
                                                .filter(Boolean)
                                                .join(' ')}
                                        </span>
                                    </motion.div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {!response || response?.alldoctors?.length === 0 ? (
                    <NoPosts />
                ) : (
                    <div
                        id={LIST}
                        className="overflow-auto flex-1 flex flex-col w-full bg-background-secondary hide-scrollbar"
                    >
                        <div className="relative before:absolute before:z-1 before:w-16 before:inset-y-2 before:bg-gradient-to-r before:from-white after:absolute after:z-1 after:w-16 after:inset-y-2 after:bg-gradient-to-l after:from-white before:left-0 after:right-0">
                            <div className="flex items-center w-full space-x-16 hide-scrollbar px-16 overflow-auto bg-white">
                                <AnimatePresence>
                                    {response.alldoctors?.map((d) => (
                                        <div
                                            key={d._id}
                                            id={d._id}
                                            onClick={() => this.onDocSelect(d._id)}
                                            className={`py-16 border-b-2 ${
                                                true ? 'border-actionPrimary' : 'border-transparent'
                                            }`}
                                            // initial={false}
                                            // exit={{ height: 0, opacity: 0 }}
                                            // transition={{ duration: 1, ease: 'easeIn' }}
                                        >
                                            <div
                                                className={`flex items-center justify-center w-56 h-56 border-2 rounded-12 ${
                                                    true
                                                        ? 'border-actionPrimary'
                                                        : 'border-transparent'
                                                }`}
                                            >
                                                <img
                                                    src={
                                                        d.profile.personal.pic_small ||
                                                        d.profile.personal.pic
                                                    }
                                                    className="w-full h-full rounded-12"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </AnimatePresence>
                            </div>
                        </div>

                        {currentDoc && (
                            <div className="flex items-center justify-between p-16 border-t border-b border-seperator-dark bg-white">
                                <div>
                                    <p className="leading-7 text-text-primary">
                                        Dr.{' '}
                                        {[
                                            currentDoc?.profile.personal.name.f,
                                            currentDoc?.profile.personal.name.l,
                                        ]
                                            .filter(Boolean)
                                            .join(' ')}
                                    </p>
                                    {currentDoc?.profile?.professional?.major_speciality?.name && (
                                        <p className="leading-4.5 text-text-secondary text-13">
                                            {
                                                currentDoc?.profile?.professional?.major_speciality
                                                    ?.name
                                            }
                                        </p>
                                    )}
                                </div>
                                {/* <button className="px-16 py-10 secondary-btn btn">Unfollow</button> */}
                            </div>
                        )}

                        {/* <PullToRefreshWrapper onRefresh={this.callApi} id={LIST}> */}
                        <div className="flex flex-col flex-1 p-16 space-y-16 hide-scrollbar">
                            {response.posts &&
                                response.posts.length > 0 &&
                                postFetchState === 'success' && (
                                    <div>
                                        <p
                                            style={{ lineHeight: 2 }}
                                            className="text-text-secondary  text-11 uppercase tracking-1px font-700"
                                        >
                                            {response.posts?.length} Posts
                                        </p>
                                        <div className="w-24 h-2 bg-status-error rounded-4 mb-12"></div>
                                    </div>
                                )}

                            {postFetchState === 'loading' ? (
                                <PostShimmer />
                            ) : !response.posts?.length ? (
                                <NoPosts />
                            ) : (
                                response.posts?.map((p) => (
                                    <div
                                        key={p._id}
                                        id={p._id}
                                        className="bg-white rounded-12 shadow-usecase-card-elevated"
                                    >
                                        {p.meta.display.link &&
                                            p.meta.display.file_type === 'IMG' && (
                                                <img
                                                    src={p.meta.display.link}
                                                    className="w-full rounded-t-12"
                                                ></img>
                                            )}
                                        <div className="p-16 space-y-16">
                                            <div className="space-y-6">
                                                <p
                                                    className="leading-6 text-text-secondary text-18 font-700"
                                                    style={{ overflowWrap: 'break-word' }}
                                                >
                                                    {p.meta.display.title}
                                                </p>
                                                <p
                                                    style={{
                                                        overflowWrap: 'break-word',
                                                        whiteSpace: 'break-spaces',
                                                    }}
                                                    className="leading-7 text-text-secondary text-16"
                                                >
                                                    {p.meta.display.description}
                                                </p>
                                                <div className="flex items-center space-x-4">
                                                    <div className="flex items-center justify-center w-16 h-16">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            className="w-10 h-10 fill-text-secondary"
                                                        >
                                                            <path d="M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z" />
                                                        </svg>
                                                    </div>
                                                    <p className="leading-6 text-text-secondary text-14">
                                                        {moment(p.updated_at).format('DD MMM')} at{' '}
                                                        {moment(p.updated_at).format('hh:mm A')}
                                                    </p>
                                                </div>
                                            </div>

                                            {p.meta.sa_id ? (
                                                <button
                                                    onClick={() => {
                                                        if (
                                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                            // @ts-ignore
                                                            !window.Eka &&
                                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                            // @ts-ignore
                                                            !window?.webkit?.messageHandlers
                                                                ?.navigate
                                                        ) {
                                                            window.open('https://eka.im');
                                                            return;
                                                        }

                                                        const data = {
                                                            doctor_oid: p.docid,
                                                            doc_id: p.docid,
                                                            wflow_id: p.meta.sa_id,
                                                        };

                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        window?.Eka?.getAppointmentDetails(
                                                            JSON.stringify(data),
                                                        );

                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        // window?.Eka?.navigate(
                                                        //     JSON.stringify({
                                                        //         page_identifier: 'self_assessment',
                                                        //         pageId: 3,
                                                        //         params: data,
                                                        //     }),
                                                        // );

                                                        window?.webkit?.messageHandlers?.navigate?.postMessage(
                                                            JSON.stringify({
                                                                page_identifier: 'self_assessment',
                                                                pid: 'self_assessment',
                                                                pageId: 3,
                                                                params: data,
                                                            }),
                                                        );
                                                    }}
                                                    className="px-10 py-8 primary-btn btn--small"
                                                >
                                                    Start Assessment
                                                </button>
                                            ) : p.meta.display.link ? (
                                                <a
                                                    href={
                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        window?.webkit?.messageHandlers?.navigate
                                                            ?.postMessage ||
                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        window?.Eka?.navigateTo
                                                            ? ''
                                                            : p.meta.display.link
                                                    }
                                                    className="px-10 py-8 primary-btn btn--small"
                                                    onClick={() => {
                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        window?.webkit?.messageHandlers?.navigate
                                                            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                              // @ts-ignore
                                                              window?.webkit?.messageHandlers?.navigate?.postMessage(
                                                                  JSON.stringify({
                                                                      page_identifier: 'browser',
                                                                      pid: 'browser',
                                                                      pageId: 2,
                                                                      params: {
                                                                          url: p.meta.display.link,
                                                                      },
                                                                  }),
                                                              )
                                                            : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                              // @ts-ignore
                                                              window?.Eka?.navigateTo(
                                                                  'browser',
                                                                  JSON.stringify({
                                                                      url: p.meta.display.link,
                                                                  }),
                                                              );
                                                    }}
                                                >
                                                    View Link
                                                </a>
                                            ) : null}
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                        {/* </PullToRefreshWrapper> */}
                    </div>
                )}
                {/* <div className="flex justify-center bg-white">
                    <button
                        onClick={() => window.open('https://eka.im')}
                        className="px-10 py-8 primary-btn btn--small"
                        style={{ margin: 16 }}
                    >
                        See All Messages
                    </button>
                </div> */}
            </div>
        );
    }
}

export default PostPage;

const NoPosts: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center flex-1 bg-background-secondary">
            <div>
                <svg
                    width="124"
                    height="124"
                    viewBox="0 0 124 124"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M95.1461 14.3529C71.3208 14.3529 54.9597 2.01147 43.4794 2.01147C31.9991 2.01147 7.88794 8.61103 7.88794 61.4247C7.88794 114.238 40.3243 121.988 52.9516 121.988C112.082 121.992 137.34 14.3529 95.1461 14.3529Z"
                        fill="white"
                    ></path>
                    <path
                        d="M69.75 90.4167H29.2778C25.4717 90.4167 22.3889 87.3339 22.3889 83.5278V30.1389C22.3889 26.3328 25.4717 23.25 29.2778 23.25H69.75C73.5561 23.25 76.6389 26.3328 76.6389 30.1389V83.5278C76.6389 87.3339 73.5561 90.4167 69.75 90.4167Z"
                        fill="white"
                    ></path>
                    <path
                        d="M100.75 97.4605C100.75 99.2688 99.2584 100.75 97.4363 100.75H61.0079C59.1858 100.75 57.6943 99.2688 57.6943 97.4605C57.6943 96.837 57.8597 96.2446 58.1903 95.752L76.4046 66.1608C76.966 65.2067 78.0269 64.5833 79.2187 64.5833C80.4104 64.5833 81.4713 65.2067 82.0328 66.1608L100.247 95.752C100.585 96.2446 100.75 96.837 100.75 97.4605Z"
                        fill="white"
                    ></path>
                    <path
                        d="M30.1389 83.5278V30.1389C30.1389 26.3328 33.2217 23.25 37.0278 23.25H29.2778C25.4717 23.25 22.3889 26.3328 22.3889 30.1389V83.5278C22.3889 87.3339 25.4717 90.4167 29.2778 90.4167H37.0278C33.2217 90.4167 30.1389 87.3339 30.1389 83.5278Z"
                        fill="white"
                    ></path>
                    <path
                        d="M97.4364 103.333H61.008C57.7564 103.333 55.1111 100.698 55.1111 97.464C55.1111 96.3101 55.4349 95.2217 56.048 94.3089L74.2036 64.8072C75.2197 63.0884 77.1486 62 79.2222 62C81.2957 62 83.2246 63.0884 84.2614 64.8486L102.452 94.395C103.01 95.2217 103.333 96.3101 103.333 97.464C103.333 100.698 100.688 103.333 97.4364 103.333ZM79.2222 67.1667C78.9191 67.1667 78.7159 67.332 78.6297 67.4732L60.2778 97.464C60.2778 97.8429 60.6119 98.1667 61.008 98.1667H97.4364C97.8325 98.1667 98.1666 97.8429 98.1666 97.464C98.1666 97.3503 98.146 97.247 98.1081 97.1953L79.8353 67.518C79.7285 67.332 79.5253 67.1667 79.2222 67.1667Z"
                        fill="#CFCAFF"
                    ></path>
                    <path
                        d="M79.2222 96.4445C80.649 96.4445 81.8056 95.2879 81.8056 93.8612C81.8056 92.4344 80.649 91.2778 79.2222 91.2778C77.7955 91.2778 76.6389 92.4344 76.6389 93.8612C76.6389 95.2879 77.7955 96.4445 79.2222 96.4445Z"
                        fill="#E4DFFF"
                    ></path>
                    <path
                        d="M49.359 93.0001H30.139C24.9137 93.0001 20.6667 88.7531 20.6667 83.5279V30.139C20.6667 24.9137 24.9137 20.6667 30.139 20.6667H69.7501C74.9753 20.6667 79.2223 24.9137 79.2223 30.139V54.5256H74.0556V30.139C74.0556 27.7657 72.1233 25.8334 69.7501 25.8334H30.139C27.7657 25.8334 25.8334 27.7657 25.8334 30.139V83.5279C25.8334 85.9011 27.7657 87.8334 30.139 87.8334H49.359V93.0001Z"
                        fill="#CFCAFF"
                    ></path>
                    <path
                        d="M66.3055 48.2222H33.5833V53.3888H66.3055V48.2222Z"
                        fill="#CFCAFF"
                    ></path>
                    <path d="M52.5277 62H33.5833V67.1667H52.5277V62Z" fill="#CFCAFF"></path>
                    <path
                        d="M49.0833 34.4443H33.5833V39.611H49.0833V34.4443Z"
                        fill="#CFCAFF"
                    ></path>
                    <path
                        d="M81.8056 75.7778H76.6389V85.2501H81.8056V75.7778Z"
                        fill="#E4DFFF"
                    ></path>
                </svg>
            </div>
            <p className="leading-6 text-center text-text-tertiary font-700 text-20">
                No posts to show
            </p>
        </div>
    );
};

const PostShimmer: React.FC = () => {
    return (
        <div className="p-16 space-y-16 bg-white rounded-12 shadow-usecase-card-elevated">
            <div className="space-y-6">
                <p className="leading-6 text-text-secondary text-18 font-700 shine"></p>
                <p className="leading-7 text-text-secondary text-16 shine"></p>
                <p className="leading-7 text-text-secondary text-16 shine"></p>
                <div className="flex items-center space-x-4">
                    <div className="flex items-center justify-center w-16 h-16 shine"></div>
                    <p className="leading-6 text-text-secondary text-14 shine"></p>
                </div>
            </div>
            <button className="px-16 py-10 primary-btn btn shine w-64 h-32"></button>
        </div>
    );
};

const FeedLoader: React.FC = () => {
    return (
        <div className="flex flex-col h-full overflow-hidden">
            <div className="flex items-center justify-between w-full">
                <div className="flex items-center w-full">
                    <p className="p-16 leading-6 text-text-primary text-20 font-700">My Feed</p>
                </div>
            </div>
            <div className="grid items-center justify-start w-full grid-flow-col space-x-16 overflow-x-auto justify-items-start hide-scrollbar after:w-16 after:h-full before:w-16 before:h-full">
                <div className="py-16 ">
                    <div className="flex items-center justify-center w-56 h-56 rounded-12 shine"></div>
                </div>
                <div className="py-16 ">
                    <div className="flex items-center justify-center w-56 h-56 rounded-12 shine"></div>
                </div>
            </div>
            <div className="flex items-center justify-between p-16 border-t border-b border-seperator-dark">
                <div>
                    <div className="shine w-120"></div>
                    <div className="shine w-52"></div>
                </div>
            </div>
            <PostShimmer />
        </div>
    );
};
